var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "content-header row" }, [
      _c("div", { staticClass: "content-header-left col-md-7 col-12 mb-2" }, [
        _c("div", { staticClass: "row breadcrumbs-top" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h2", { staticClass: "content-header-title float-left mb-0" }, [
              _vm._v("PAYE SCHEDULE\n                     ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "breadcrumb-wrapper col-12" }, [
              _c("ol", { staticClass: "breadcrumb" }, [
                _c(
                  "li",
                  { staticClass: "breadcrumb-item" },
                  [
                    _c("router-link", { attrs: { to: "/home" } }, [
                      _vm._v(
                        "\n                                     " +
                          _vm._s(_vm.trans("general.home")) +
                          "\n                                 "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", { staticClass: "breadcrumb-item active" }, [
                  _vm._v(
                    "\n                                 NOMINAL ROLL MNGR\n                             "
                  )
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "content-header-right text-md-right col-md-5 col-12 d-md-block d-none"
        },
        [
          _c("div", { staticClass: "form-group breadcrum-right" }, [
            !_vm.showFilterPanel
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-sm pull-right",
                    on: {
                      click: function($event) {
                        _vm.showFilterPanel = !_vm.showFilterPanel
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "feather icon-filter" }),
                    _vm._v(" " + _vm._s(_vm.trans("general.filter")))
                  ]
                )
              : _vm._e()
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content-body" }, [
      _c("section", { attrs: { id: "basic-datatable" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.showFilterPanel
                  ? _c("div", { staticClass: "card border-bottom" }, [
                      _c("div", { staticClass: "card-header" }, [
                        _c("h4", { staticClass: "mt-2 text-center" }, [
                          _vm._v("PAYE SCHEDULE")
                        ]),
                        _c("br")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-content" }, [
                        _c("div", { staticClass: "card-body" }, [
                          _c(
                            "form",
                            {
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.storePayment.apply(null, arguments)
                                },
                                keydown: function($event) {
                                  return _vm.paymentForm.errors.clear(
                                    $event.target.name
                                  )
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "m-2 text- col" }, [
                                  _c("b", { staticClass: "text-left" }, [
                                    _vm._v(
                                      "Total No.of Staff: " +
                                        _vm._s(_vm.staffs.total)
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "m-2 col" }, [
                                  _c("b", [
                                    _vm._v(
                                      "Total PAYE Per Annum: " +
                                        _vm._s(_vm.annualPayee)
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "m-2 ml-4 col" }, [
                                  _c("p", { staticClass: "b" }, [
                                    _c("b", [
                                      _vm._v(
                                        "Total Monthly PAYE: " +
                                          _vm._s(_vm.monthlyPayee)
                                      )
                                    ])
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "m-1 row" }, [
                                _c("div", { staticClass: "col-md-9" }, [
                                  _c("label", { staticClass: "form-label" }, [
                                    _vm._v("Select Month to file")
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.date,
                                        expression: "date"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: { name: "date", type: "month" },
                                    domProps: { value: _vm.date },
                                    on: {
                                      input: [
                                        function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.date = $event.target.value
                                        },
                                        _vm.formatMonth
                                      ]
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-3" },
                                  [
                                    _c(
                                      "button-spinner",
                                      {
                                        staticClass:
                                          "btn btn-primary mr-1 mb-1 waves-effect waves-light pull-right",
                                        staticStyle: {
                                          height: "39px",
                                          color: "#fff"
                                        },
                                        attrs: {
                                          "is-loading":
                                            _vm.paymentForm.isLoading,
                                          disabled: _vm.paymentForm.isLoading
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                                 Pay now\n                                             "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        ])
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-header" }, [
                  _vm.staffs.total
                    ? _c(
                        "h4",
                        { staticClass: "card-title" },
                        [
                          _c("sort-by", {
                            attrs: {
                              "order-by-options": _vm.orderByOptions,
                              "sort-by": _vm.filterStaffForm.sort_by,
                              order: _vm.filterStaffForm.order
                            },
                            on: {
                              updateSortBy: function(value) {
                                _vm.filterStaffForm.sort_by = value
                              },
                              updateOrder: function(value) {
                                _vm.filterStaffForm.order = value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-content" }, [
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _vm.staffs.total
                        ? _c("div", { staticClass: "table-responsive" }, [
                            _c("table", { staticClass: "table" }, [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", [
                                    _vm._v(
                                      _vm._s(_vm.trans("general.serial_number"))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("ITAS ID")]),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("Staff Name")]),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("Basic Salary(Month)")]),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("Total Income")]),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("Gross Salary")]),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("Taxable Income")]),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("Tax Annually")]),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("Tax Monthly")])
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "tbody",
                                _vm._l(_vm.staffs.data, function(staff, index) {
                                  return _c("tr", [
                                    _c("td", {
                                      domProps: {
                                        textContent: _vm._s(index + 1)
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("td", {
                                      domProps: {
                                        textContent: _vm._s(staff.itas_id)
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("td", {
                                      domProps: {
                                        textContent: _vm._s(staff.name)
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatMoney")(
                                            staff.earned_basic
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatMoney")(
                                            staff.total_income
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatMoney")(
                                            staff.gross_salary
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatMoney")(
                                            staff.taxable_income
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatMoney")(
                                            staff.tax_annually
                                          )
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatMoney")(
                                            staff.tax_monthly
                                          )
                                        )
                                      )
                                    ])
                                  ])
                                }),
                                0
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.staffs.total
                        ? _c(
                            "module-info",
                            {
                              attrs: {
                                module: "staff",
                                title: "module_info_title",
                                description: "module_info_description",
                                icon: "check-circle"
                              }
                            },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "btn" }, slot: "btn" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary btn-md",
                                      on: {
                                        click: function($event) {
                                          return _vm.$router.push(
                                            "/paye/upload"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "feather icon-plus"
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.trans("general.add_new"))
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("pagination-record", {
                        attrs: {
                          "page-length": _vm.filterStaffForm.page_length,
                          records: _vm.staffs
                        },
                        on: {
                          "update:pageLength": function($event) {
                            return _vm.$set(
                              _vm.filterStaffForm,
                              "page_length",
                              $event
                            )
                          },
                          "update:page-length": function($event) {
                            return _vm.$set(
                              _vm.filterStaffForm,
                              "page_length",
                              $event
                            )
                          },
                          updateRecords: _vm.getStaffs
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          staticStyle: { display: "none" },
          attrs: {
            id: "confirmPayment",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "paymentDetail",
            "aria-hidden": "true"
          }
        },
        [
          _c("div", { staticClass: "modal-dialog modal-lg" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(0),
              _vm._v(" "),
              _vm.showConfirm
                ? _c("div", { staticClass: "modal-body" }, [
                    _c("h4", [_vm._v("Confirm Payment")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Transaction Reference: "),
                      _c("strong", [_vm._v(_vm._s(_vm.reference))])
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("TAX ID: "),
                      _c("strong", [_vm._v(_vm._s(_vm.tax_id))])
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Phone NO: "),
                      _c("strong", [_vm._v(_vm._s(_vm.paymentForm.phone))])
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Email: "),
                      _c("strong", [_vm._v(_vm._s(_vm.paymentForm.email))])
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Year: "),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.paymentForm.payment_year))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("table", { staticClass: "table" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", [_vm._v(_vm._s(_vm.pay_item_name))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.paymentForm.amount))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.paymentForm.description))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.paymentForm.month_from))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(_vm.paymentForm.month_to))])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Total Amount: "),
                      _c("strong", [_vm._v(_vm._s(_vm.paymentForm.amount))])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-danger waves-effect text-left",
                    attrs: { type: "button", "data-dismiss": "modal" }
                  },
                  [_vm._v(_vm._s(_vm.trans("general.close")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary waves-effect",
                    attrs: { type: "button" },
                    on: { click: _vm.generateRRR }
                  },
                  [_vm._v("Generate RRR")]
                ),
                _vm._v(" "),
                _vm.paymentForm.gateway_id != 3
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-primary waves-effect",
                        attrs: { type: "button" },
                        on: { click: _vm.confirmPayment }
                      },
                      [_vm._v("Confirm")]
                    )
                  : _vm._e()
              ])
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "modal-title", attrs: { id: "paymentDetail" } }, [
        _vm._v("Payment Confirmation")
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-hidden": "true"
          }
        },
        [_vm._v("×")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Item")]),
      _vm._v(" "),
      _c("th", [_vm._v("Amount")]),
      _vm._v(" "),
      _c("th", [_vm._v("Description")]),
      _vm._v(" "),
      _c("th", [_vm._v("Month From")]),
      _vm._v(" "),
      _c("th", [_vm._v("Month To")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }